import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from '../config/axios';

class Regex extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pattern: '',
            isSSN: false,
            formFields: {
                ssn: '',
                pattern: "(?<=\\s|^)[a-z]*(?!666|000)(?:\\d{9}|[0-9]{3}([ -._])(?!00)[0-9]{2}\\1(?!0000)[0-9]{4})[a-z]*(?=\\s|$)"
            }
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } }, () => console.log(this.state.formFields));
    }

    handleSubmit(event) {
        event.preventDefault();
        let postdata = {};

        postdata.contactReason = this.state.formFields.ssn;
        postdata.contactName = this.state.formFields.pattern;
        Axios.post(`/api/RegexTest`, postdata
        ).then(response => {
            var isSSN = response.data;
            this.setState({
                isSSN
            }, () => console.log(this.state.isSSN));
        }).catch(error => {
            console.log(error);
        });
    }

    render() {
        return (
            <div style={{ height: '300px' }}>

                <div className="row rowMargin">
                    <div className="form-group col-sm-6">
                        <input type="text" className="form-control" id="pattern" name="pattern" value={this.state.formFields.pattern} onChange={this.handleInputChange} placeholder="Regex" />
                    </div>
                </div>

                <div className="row rowMargin">
                    <div className="form-group col-sm-6">
                        <input type="text" className="form-control" id="ssn" name="ssn" placeholder="SSN" value={this.state.formFields.ssn} onChange={this.handleInputChange} />
                    </div>
                </div>
                <div className="row rowMargin">
                    <div className="form-group col-sm-6">
                        <button type="submit" className="btn btn-warning colorBlack" onClick={this.handleSubmit}>Submit</button>
                    </div>
                </div>
                <div className="row rowMargin">
                    <div className="form-group col-sm-6">
                        <input value={this.state.isSSN} className="form-control" readOnly />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Regex);


// WEBPACK FOOTER //
// ./src/components/Regex.js